function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "rxjs/add/operator/share";
import "rxjs/add/observable/of";
import { ConnectionStatus } from "botframework-directlinejs";
import { BehaviorSubject } from "rxjs";
import { Observable } from "rxjs/Observable";
import { uuidv4 } from "@microsoft/omnichannel-chat-sdk";
export default class MockAdapter {
  constructor() {
    _defineProperty(this, "activityObserver", void 0);
    _defineProperty(this, "activity$", void 0);
    _defineProperty(this, "connectionStatus$", new BehaviorSubject(ConnectionStatus.Uninitialized));
    this.activity$ = new Observable(observer => {
      this.activityObserver = observer;
      Promise.resolve().then(async () => {
        this.connectionStatus$.next(ConnectionStatus.Online);
        try {
          if (this.connectionStatus$) {
            this.connectionStatus$.next(ConnectionStatus.Online);
          }
        } catch (err) {
          this.connectionStatus$.next(ConnectionStatus.FailedToConnect);
          console.error(err);
        }
      });
    }).share();
  }
  postActivity(activity) {
    if (activity) {
      var _activity$text;
      let modActivity;
      let typingActivity;
      const userId = "userId",
        botId = "botId";
      if ((_activity$text = activity.text) !== null && _activity$text !== void 0 && _activity$text.startsWith(":")) {
        var _this$activityObserve, _this$activityObserve2;
        modActivity = {
          ...activity,
          id: uuidv4(),
          from: {
            ...activity.from,
            id: botId,
            name: "Bot",
            role: "bot"
          },
          text: activity.text.substr(1)
        };
        typingActivity = {
          id: uuidv4(),
          from: {
            id: uuidv4(),
            name: "Bot",
            role: "bot"
          },
          type: "typing"
        };
        (_this$activityObserve = this.activityObserver) === null || _this$activityObserve === void 0 ? void 0 : _this$activityObserve.next(modActivity); // mock echo message
        (_this$activityObserve2 = this.activityObserver) === null || _this$activityObserve2 === void 0 ? void 0 : _this$activityObserve2.next(typingActivity); // mock typing
      } else {
        var _this$activityObserve3;
        modActivity = {
          ...activity,
          id: uuidv4(),
          from: {
            ...activity.from,
            id: userId,
            name: "User",
            role: "user"
          }
        };
        (_this$activityObserve3 = this.activityObserver) === null || _this$activityObserve3 === void 0 ? void 0 : _this$activityObserve3.next(modActivity); // mock message sent
      }
    }

    return Observable.of(activity.id || "");
  }
  end() {
    return;
  }
}